import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import usePageMeta from "@/hooks/use-page-meta";
import { MapPin, ArrowUpRight, Clock3 } from "lucide-react";
import { LOCATIONS } from "@/constants/content";

export default function LocationsListPage() {
  usePageMeta("Home Healthcare Locations in Delhi NCR — KinFlex", "KinFlex Home Healthcare serves Delhi, Noida, Greater Noida, Ghaziabad, Gurugram & Faridabad. Same-day nurse visits available.");
  return (
    <Layout>
      <section className="pt-32 pb-12 md:pt-40 md:pb-16 bg-hero-gradient relative overflow-hidden">
        <div className="absolute inset-0 bg-medical-grid opacity-60 pointer-events-none" />
        <div className="container-page relative max-w-4xl">
          <div className="eyebrow mb-4">Areas We Serve</div>
          <h1 className="font-display font-bold text-slate-900 text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Home healthcare across <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">Delhi NCR</span>.
          </h1>
          <p className="mt-6 text-lg text-slate-600 max-w-2xl">
            KinFlex nurses are stationed across every corner of Delhi, Noida, Greater Noida, Ghaziabad, Gurugram and Faridabad — enabling rapid, same-day home visits.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white">
        <div className="container-page grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {LOCATIONS.map((l) => (
            <Link
              key={l.slug}
              to={`/locations/${l.slug}`}
              className="group rounded-2xl overflow-hidden bg-white border border-slate-200/70 hover:border-[#0A84FF]/30 hover:shadow-xl hover:-translate-y-1 transition-all"
              data-testid={`locations-list-${l.slug}`}
            >
              <div className="relative h-44 overflow-hidden">
                <img src={l.image} alt={l.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/20 to-transparent" />
                <div className="absolute bottom-4 left-5 text-white">
                  <div className="flex items-center gap-1.5 text-[11px] text-white/85">
                    <Clock3 className="h-3 w-3" /> {l.responseTime}
                  </div>
                  <div className="font-display font-bold text-2xl mt-0.5">Home Healthcare in {l.name}</div>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-slate-600 leading-relaxed line-clamp-2 flex items-start gap-1.5">
                  <MapPin className="h-3.5 w-3.5 mt-0.5 shrink-0" style={{ color: '#0A84FF' }} /> {l.coverage}
                </p>
                <div className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0A84FF] group-hover:gap-2.5 transition-all">
                  Explore {l.name} <ArrowUpRight className="h-4 w-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
